export default __webpack_public_path__ + "static/media/Copy.54a7bb33.svg";